(function () {
  var ATTRS = ['href', 'src', 'poster', 'action'];
  var SELECTOR = ATTRS.map(function (attr) {
    return '[' + attr + '*="\\\\\\""],[' + attr + '^="\\""],[' + attr + '$="\\""]';
  }).join(',');

  function clean(value) {
    if (!value) return value;
    var next = String(value).trim();
    next = next.replace(/&quot;/g, '"');
    next = next.replace(/^(?:\\+")+/, '');
    next = next.replace(/(?:\\+")+$/, '');
    next = next.replace(/^"+/, '');
    next = next.replace(/"+$/, '');
    return next;
  }

  function sanitizeRoot(root) {
    if (!root || !root.querySelectorAll) return;
    var nodes = [];
    ATTRS.forEach(function (attr) {
      root.querySelectorAll('[' + attr + ']').forEach(function (node) {
        nodes.push([node, attr]);
      });
    });
    nodes.forEach(function (pair) {
      var node = pair[0];
      var attr = pair[1];
      var before = node.getAttribute(attr);
      var after = clean(before);
      if (after && after !== before) node.setAttribute(attr, after);
    });
  }

  function sanitizeFrames(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('iframe').forEach(function (frame) {
      try {
        var doc = frame.contentDocument || (frame.contentWindow && frame.contentWindow.document);
        sanitizeRoot(doc);
      } catch (error) {}
    });
  }

  function run() {
    sanitizeRoot(document);
    sanitizeFrames(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', function () {
    run();
    setTimeout(run, 250);
    setTimeout(run, 1000);
  });

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function () {
      run();
    });
    if (document.documentElement) {
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ATTRS
      });
    }
  }
})();
